var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOffice28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2015 2.09886C15.3283 2.00451 15.4923 1.97567 15.6437 2.02109L25.6437 5.02109C25.8552 5.08454 26 5.2792 26 5.5V23.5C26 23.7761 25.7761 24 25.5 24H7.5L7.49803 24H3.5C3.22386 24 3 23.7761 3 23.5V13.5C3 13.2239 3.22386 13 3.5 13H7V9.5C7 9.22386 7.22386 9 7.5 9H17.5C17.7761 9 18 9.22386 18 9.5V23H25V5.87202L16 3.17202V6.5C16 6.77615 15.7761 7 15.5 7C15.2239 7 15 6.77615 15 6.5V2.5C15 2.34195 15.0747 2.1932 15.2015 2.09886ZM7 14V23H4V14H7ZM8 23V13.5V10H17V23H8ZM11.5 16C11.2239 16 11 16.2239 11 16.5C11 16.7761 11.2239 17 11.5 17H13.5C13.7761 17 14 16.7761 14 16.5C14 16.2239 13.7761 16 13.5 16H11.5ZM11 19.5C11 19.2239 11.2239 19 11.5 19H13.5C13.7761 19 14 19.2239 14 19.5C14 19.7761 13.7761 20 13.5 20H11.5C11.2239 20 11 19.7761 11 19.5ZM11.5 13C11.2239 13 11 13.2239 11 13.5C11 13.7761 11.2239 14 11.5 14H13.5C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13H11.5ZM22 9.5C22 9.22386 21.7761 9 21.5 9C21.2239 9 21 9.22386 21 9.5V19.5C21 19.7761 21.2239 20 21.5 20C21.7761 20 22 19.7761 22 19.5V9.5Z",
  fill: "currentColor"
})));
export default SvgOffice28;